import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import "../home/home.scss";
import * as XLSX from "xlsx";
import { DelistedEntityTables } from "./components/DelistedEntityTables";
import { getTopThreeHistoryFileData } from "../../Api";
import Swal from "sweetalert2";
import { tabsData as importTabsData } from "../importdata/ImportData";

// Use tabs from Import module for consistency
const tabsData = importTabsData;

// Display labels for tabs
const displayLabelMap = {
    UKSanctions: "UK Sanctions",
    NONSDN: "NON SDN",
};

// Map tabs to API file_type values
const apiFileTypeMap = {
    OFAC: "OFAC_SDN",
    UKSanctions: "UK_Sanctions",
    NONSDN: "OFAC_NON_SDN",
    Address: "OFAC_ADD_SDN", // default; add subtype toggle if needed
    PEP: "PEP",
    "Watch List": "WATCH_LIST",
    Negative: "Others",
};

function DelistedEntity() {
    // For Files Comparision
    const [selectedTab, setSelectedTab] = useState(0);
    const [sourceFile, setSourceFile] = useState("");
    const [historyFile, setHistoryFile] = useState("");
    const [compareResult, setCompareResult] = useState([]);
    const [showCompareTable, setShowCompareTable] = useState(false);
    const [showBankFormat, setShowBankFormat] = useState(false);
    const [submittedData, setSubmittedData] = useState(
        tabsData.reduce((acc, tab) => {
        acc[tab] = [];
        return acc;
        }, {})
    );
    const [historyOptions, setHistoryOptions] = useState([]);

    // For comparision
    const handleCompare = () => {
        if (!sourceFile || !historyFile) return;
        // For demo: always show at least one missing row
        const sourceRows = previewTableData;
        const historyRows = previewTableData.slice(1); // Remove first row for demo
        // Find missing rows by SDN_NAME (as example)
        const missing = sourceRows.filter(
        (s) => !historyRows.some((h) => h.SDN_NAME === s.SDN_NAME)
        );
        setCompareResult(missing);
        setShowCompareTable(true);
        setShowBankFormat(false);
    };

    const handleGenerateBankFormat = () => {
        setShowBankFormat(true);
    };

    const handleDownloadExcel = () => {
        const data = showBankFormat ? previewTableData : compareResult;
        if (!data || data.length === 0) return;
        const headers = Object.keys(data[0]);
        const rows = data.map((row) => headers.map((h) => row[h]));
        const sheetData = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Compare Data");
        XLSX.writeFile(wb, "compare_result.xlsx");
    };

    useEffect(() => {
        const load = async () => {
            const tabKey = tabsData[selectedTab];
            const file_type = apiFileTypeMap[tabKey] || tabKey;
            const bank_code = localStorage.getItem("bank_code") || "";
            Swal.fire({
                html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
                showConfirmButton: false,
                heightAuto: false,
                customClass: { popup: "loader-swal" },
                allowOutsideClick: false,
            })
            const response = await getTopThreeHistoryFileData({file_type, bank_code});
            Swal.close();
            if(response.status === "S" && Array.isArray(response.result_info)) {
                setHistoryOptions(response.result_info.map(f => ({
                    id: f.file_name,
                    name: f.file_name,
                    date: f.load_date,
                    time: f.load_time,
                })));
            } else {
                setHistoryOptions([]);
            }
            setSourceFile("");
            setHistoryFile("");
        }
        load();
    }, [selectedTab]);

    
    // Change submittedData to store files per tab
    const allFiles = submittedData[tabsData[selectedTab]] || [];
    const isDemoTab = ["OFAC", "UK sanctions", "NON SDN"].includes(
        tabsData[selectedTab]
    );
    // const fileOptions = isDemoTab ? demoFiles[tabsData[selectedTab]] : allFiles;

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setShowBankFormat(false);
        setShowCompareTable(false);
        setSourceFile("");
        setHistoryFile("");
    };

    const previewTableData = [
        {
        id: 0,
        ENT_NUM: 36,
        SDN_NAME: "AEROCARIBBEAN AIRLINES",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 1,
        ENT_NUM: 173,
        SDN_NAME: "ANGLO-CARIBBEAN CO., LTD.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 2,
        ENT_NUM: 306,
        SDN_NAME: "BANCO NACIONAL DE CUBA",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "a.k.a. 'BNC'.",
        },
        {
        id: 3,
        ENT_NUM: 424,
        SDN_NAME: "BOUTIQUE LA MAISON",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 4,
        ENT_NUM: 475,
        SDN_NAME: "CASA DE CUBA",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 5,
        ENT_NUM: 480,
        SDN_NAME: "CECOEX, S.A.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 6,
        ENT_NUM: 535,
        SDN_NAME: "CIMEX",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 7,
        ENT_NUM: 536,
        SDN_NAME: "CIMEX IBERICA",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 8,
        ENT_NUM: 537,
        SDN_NAME: "CIMEX, S.A.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
        {
        id: 9,
        ENT_NUM: 540,
        SDN_NAME: "COMERCIAL IBEROAMERICANA, S.A.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-",
        },
    ];
    const modalPreviewTableData = [
        {
        id: 0,
        col1: "BANKSESSXXXX",
        col2: "I103BANKNO2XXXXN",
        col3: "SEPA, MNO987123654",
        col4: "",
        col20: "REF987123654",
        col23B: "CRED",
        col32A: "240303SEK3000",
        col50A: "/9871236540 OLIVER ERICSON",
        col57A: "BANKNO2X",
        col59: "/5566778899 HENRY JOHNSTON",
        col70: "HOUSE RENT",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 1,
        col1: "BANKFIHHXXXX",
        col2: "I103BANKDKKKXXXXN",
        col3: "SEPA, PQR456789123",
        col4: "",
        col20: "REF456789123",
        col23B: "CRED",
        col32A: "240303SEK5000",
        col50A: "/4567891230 EMMA WILSON",
        col57A: "BANKDKKKX",
        col59: "/1122334455 JAMES BROWN",
        col70: "CAR LOAN",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 2,
        col1: "BANKPTPLXXXX",
        col2: "I103BANKGRXXXXXXN",
        col3: "SEPA, STU654321987",
        col4: "",
        col20: "REF654321987",
        col23B: "CRED",
        col32A: "240303SEK7000",
        col50A: "/6543219870 LUCAS MARTIN",
        col57A: "BANKGRXXX",
        col59: "/9988776655 SARAH DAVIS",
        col70: "HOME RENOVATION",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 3,
        col1: "BANKESPBXXXX",
        col2: "I103BANKITRRXXXXN",
        col3: "SEPA, VWX321654987",
        col4: "",
        col20: "REF321654987",
        col23B: "CRED",
        col32A: "240303SEK4000",
        col50A: "/3216549870 SOPHIA LEE",
        col57A: "BANKITRRX",
        col59: "/4455667788 MICHAEL WHITE",
        col70: "EDUCATION",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 4,
        col1: "BANKDEFFXXXX",
        col2: "I103BANKFRXXXXXXN",
        col3: "SEPA, YZA987654321",
        col4: "",
        col20: "REF987654321",
        col23B: "CRED",
        col32A: "240303SEK6000",
        col50A: "/9876543210 THOMAS CLARK",
        col57A: "BANKFRXXX",
        col59: "/6677889900 LUCY ADAMS",
        col70: "BUSINESS EXPENSE",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
    ];

  return (
    <div className="home-page">
        <div className="page-container">
            {/* Horizontal Scrolling Tabs */}
            <div
                className="row border-bottom mb-3"
                style={{ borderColor: "#dee2e6" }}
            >
                <div className="col-12">
                    <Tabs
                        value={selectedTab}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="reference data tabs"
                        sx={{
                            "& .MuiTabs-indicator": { display: "none" },
                            "& .MuiTab-root": {
                            color: "rgba(0, 0, 0, 0.6)",
                            backgroundColor: "#ccc",
                            padding: "15px",
                            borderRadius: "4px 4px 0 0",
                            marginRight: "5px",
                            "&.Mui-selected": {
                                backgroundColor: "var(--theme-color)",
                                color: "white",
                                borderRadius: "4px 4px 0 0",
                            },
                            },
                        }}
                    >
                        {tabsData.map((tab, index) => (
                            <Tab key={index} label={displayLabelMap[tab] || tab} />
                        ))}
                    </Tabs>
                </div>
            </div>

            <div className="row mb-4 align-items-end">
                <div className="col-md-6">
                    <FormControl fullWidth size="small">
                    <InputLabel>Source File</InputLabel>
                    <Select
                        value={sourceFile}
                        label="Source File"
                        onChange={(e) => setSourceFile(e.target.value)}
                    >
                        {historyOptions.map((f) => (
                        <MenuItem key={f.id} value={f.id}>
                            {f.name || f.file?.name || f.fileName}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth size="small">
                    <InputLabel>History File</InputLabel>
                    <Select
                        value={historyFile}
                        label="History File"
                        onChange={(e) => setHistoryFile(e.target.value)}
                    >
                        {historyOptions.map((f) => (
                        <MenuItem key={f.id} value={f.id}>
                            {f.name || f.file?.name || f.fileName}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </div>
                <div className="text-center mt-3">
                    <Button
                    variant="contained"
                    color="primary"
                    className="btn createButton"
                    onClick={handleCompare}
                    >
                    Compare
                    </Button>
                </div>
            </div>

            {/* Use DelistedEntityTables component for all table/format UI */}
            <DelistedEntityTables
                showCompareTable={showCompareTable}
                showBankFormat={showBankFormat}
                compareResult={compareResult}
                handleGenerateBankFormat={handleGenerateBankFormat}
                handleDownloadExcel={handleDownloadExcel}
                modalPreviewTableData={modalPreviewTableData}
            />
        </div>
    </div>
  );
}

export default DelistedEntity;
